module.exports = __webpack_public_path__ + "7b9ac860a2f400110155b672eb20e1.png";